import { motion } from "framer-motion";
import { Languages, Music, Sparkles, Apple, TreePalm, Palette, Trees, UtensilsCrossed, ShieldCheck, Accessibility } from "lucide-react";
import { activities, structure, images } from "@/data/content";

const actIcons = { Languages, Music, Sparkles, Apple, TreePalm, Palette };
const structIcons = { Trees, UtensilsCrossed, ShieldCheck, Accessibility };
const actColors = { "brand-sky": "#45B7D1", "brand-pink": "#FF9ECE", "brand-orange": "#FF9F1C", "brand-green": "#4ECDC4", "brand-yellow": "#FFE66D", "brand-red": "#FF6B6B" };

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Differentials() {
  return (
    <section id="diferenciais" className="relative py-24 md:py-32 bg-surface-alt">
      <div className="mx-auto max-w-7xl px-5">
        <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} className="max-w-2xl mb-16">
          <span className="inline-block rounded-full bg-brand-pink/20 text-brand-pink px-4 py-1.5 font-700 text-sm mb-4">
            Diferenciais & atividades
          </span>
          <h2 className="font-display font-700 text-ink text-4xl md:text-5xl leading-tight">
            Experiências que ampliam o mundo da criança.
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 mb-8">
          {activities.map((a, i) => {
            const Icon = actIcons[a.icon];
            const col = actColors[a.color];
            return (
              <motion.div
                key={a.name}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-30px" }}
                className="group rounded-3xl bg-white p-6 md:p-8 shadow-[0_8px_30px_rgb(30,58,95,0.05)] hover:-translate-y-1.5 transition-transform duration-300 flex flex-col items-start gap-4"
                data-testid={`activity-${i}`}
              >
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: `${col}22` }}>
                  <Icon className="h-7 w-7" strokeWidth={2.5} style={{ color: col }} />
                </span>
                <span className="font-display font-600 text-ink text-lg md:text-xl">{a.name}</span>
              </motion.div>
            );
          })}
        </div>

        {/* Structure banner */}
        <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} className="grid lg:grid-cols-2 gap-6 items-stretch">
          <div className="relative rounded-[2rem] overflow-hidden min-h-[280px] shadow-[0_20px_60px_rgb(30,58,95,0.12)]">
            <img src={images.playground} alt="Playground e área externa" className="absolute inset-0 w-full h-full object-cover object-[50%_20%]" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="font-display font-700 text-white text-2xl">Ambiente seguro e preparado</p>
            </div>
          </div>
          <div className="rounded-[2rem] bg-white p-8 md:p-10 shadow-[0_8px_30px_rgb(30,58,95,0.05)]">
            <h3 className="font-display font-600 text-ink text-2xl mb-6">Nossa estrutura</h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {structure.map((s) => {
                const Icon = structIcons[s.icon];
                return (
                  <div key={s.name} className="flex items-center gap-3" data-testid={`structure-${s.name}`}>
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand-green/15 shrink-0">
                      <Icon className="h-5 w-5 text-brand-green" strokeWidth={2.5} />
                    </span>
                    <span className="font-body font-600 text-ink">{s.name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
